import { isMessage } from "~/polyfills/shared";
let port;
const connectListeners = new Set();
const disconnectListeners = new Set();
const messageListeners = new Set();
export function addConnectListener(listener) {
    connectListeners.add(listener);
    listener();
}
export function addDisconnectListener(listener) {
    disconnectListeners.add(listener);
}
export function addMessageListener(listener) {
    messageListeners.add(listener);
}
export const connect = () => {
    if (port) {
        return port;
    }
    try {
        port = browser.runtime.connect({ name: "ui" });
    }
    catch (ex) {
        port = null;
        disconnectListeners.forEach((listener) => listener());
        return port;
    }
    port.onMessage.addListener((message) => {
        if (!isMessage(message)) {
            return;
        }
        onMessage(message);
    });
    port.onDisconnect.addListener(onDisconnect);
    connectListeners.forEach((listener) => listener());
    return port;
};
export function listen({ type, filter, ...options }) {
    addConnectListener(() => {
        if (port) {
            port.postMessage({
                type: `${type}.listen`,
                filter,
                ...options,
            });
        }
    });
}
function onDisconnect() {
    port = null;
    setTimeout(() => connect(), 100);
}
function onMessage(message) {
    if (!message.type.endsWith(".respond")) {
        return;
    }
    messageListeners.forEach((listener) => listener(message));
}
export function removeDisconnectListener(listener) {
    disconnectListeners.delete(listener);
}
